export default "__VITE_ASSET__RsUMK8N2__"